import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10628650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle-1" }
const _hoisted_2 = { class: "subtitle-2" }
const _hoisted_3 = { class: "number-inputs-flex" }
const _hoisted_4 = { class: "subtitle-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "subtitle-1" }
const _hoisted_7 = { class: "subtitle-2" }
const _hoisted_8 = { class: "number-inputs-flex" }
const _hoisted_9 = { class: "subtitle-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "subtitle-1" }
const _hoisted_12 = { class: "subtitle-1" }
const _hoisted_13 = { class: "subtitle-1" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "subtitle-1" }
const _hoisted_16 = { class: "number-inputs-flex" }
const _hoisted_17 = { class: "subtitle-1" }
const _hoisted_18 = { class: "number-inputs-flex" }
const _hoisted_19 = { class: "subtitle-1" }
const _hoisted_20 = { class: "subtitle-1" }
const _hoisted_21 = { class: "subtitle-1" }

import {computed, Reactive, reactive, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {GuildSettings} from "@/types/GuildSettings";
import config from "@/config.json";
import i18n from "@/plugins/i18n";
import {Guild} from "@/types/Guild";
import DurationPicker from "@/components/DurationPicker.vue";
import ResetBalance from "@/components/ResetBalance.vue";
import Items from "@/components/items/Items.vue";
import BoostAlert from "@/components/BoostAlert.vue";
import CustomJobs from "@/components/customJobs/CustomJobs.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildEconomyView',
  props: {
    settings: {}
  },
  emits: ['submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute();
const store = useStore();
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let settings: Reactive<GuildSettings> = reactive(JSON.parse(JSON.stringify(props.settings)));
let valid = ref(true);
let submitting = ref(false);

const integerRules = [
  (number: number) => !(number % 1) || i18n.global.t('GuildEconomy.errors.invNumber')
]
const positiveIntegerRules = [
  (number: number) => (number >= 0 && !(number % 1)) || i18n.global.t('GuildEconomy.errors.invPosNumber')
]
const moneySymbolRules = [
  (symbol: string) => (symbol.length <= 50) || i18n.global.t('GuildEconomy.errors.invMoneySymbol')
]
const percentRules = [
  (number: number) => (number >= 0 && number <= 100 && !(number % 1)) ||
      i18n.global.t('GuildEconomy.errors.invPercent')
]

async function submit() {
  submitting.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/economy`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify(settings)
      })
  if(response.ok) emit('submitted', 'success', settings)
  else emit('submitted', 'error')
  submitting.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _unref(valid),
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.work')), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.salary')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_text_field, {
            modelValue: _unref(settings).work.min,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).work.min) = $event)),
            class: "number-input-item",
            rules: positiveIntegerRules,
            type: "number",
            color: "primary",
            label: _ctx.$t('GuildEconomy.subtitles.from')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_v_text_field, {
            modelValue: _unref(settings).work.max,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings).work.max) = $event)),
            class: "number-input-item",
            rules: positiveIntegerRules,
            type: "number",
            color: "primary",
            label: _ctx.$t('GuildEconomy.subtitles.to')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.cooldown')), 1),
        _createVNode(DurationPicker, {
          modelValue: _unref(settings).work.cooldown,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings).work.cooldown) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.moneybags')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.money')), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_text_field, {
            modelValue: _unref(settings).moneybags.min,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(settings).moneybags.min) = $event)),
            class: "number-input-item",
            rules: integerRules,
            type: "number",
            color: "primary",
            label: _ctx.$t('GuildEconomy.subtitles.from')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_v_text_field, {
            modelValue: _unref(settings).moneybags.max,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(settings).moneybags.max) = $event)),
            class: "number-input-item",
            rules: integerRules,
            type: "number",
            color: "primary",
            label: _ctx.$t('GuildEconomy.subtitles.to')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.cooldown')), 1),
        _createVNode(DurationPicker, {
          modelValue: _unref(settings).moneybags.cooldown,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(settings).moneybags.cooldown) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.moneySymbol')), 1),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(settings).moneySymbol,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(settings).moneySymbol) = $event)),
          class: "money-symbol-input",
          rules: moneySymbolRules,
          color: "primary",
          counter: "50",
          variant: "outlined",
          label: _ctx.$t('GuildEconomy.subtitles.symbol'),
          hint: _ctx.$t('GuildEconomy.subtitles.moneySymbolHint')
        }, null, 8, ["modelValue", "label", "hint"]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.commission')), 1),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(settings).commission,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(settings).commission) = $event)),
          class: "number-input",
          rules: percentRules,
          type: "number",
          color: "primary",
          label: _ctx.$t('GuildEconomy.subtitles.percent'),
          suffix: "%"
        }, null, 8, ["modelValue", "label"]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.minBet')), 1),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(settings).minBet,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(settings).minBet) = $event)),
          class: "number-input",
          rules: positiveIntegerRules,
          type: "number",
          color: "primary",
          label: _ctx.$t('GuildEconomy.subtitles.bet')
        }, null, 8, ["modelValue", "label"]),
        (!_unref(guild).settings.boost)
          ? (_openBlock(), _createBlock(BoostAlert, {
              key: 0,
              class: "alert",
              text: _ctx.$t('GuildEconomy.subtitles.boostDescription')
            }, null, 8, ["text"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.messageXp')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(settings).messageXp.chance,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(settings).messageXp.chance) = $event)),
                class: "number-input",
                rules: percentRules,
                type: "number",
                color: "primary",
                label: _ctx.$t('GuildEconomy.subtitles.chance'),
                suffix: "%"
              }, null, 8, ["modelValue", "label"]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(settings).messageXp.min,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(settings).messageXp.min) = $event)),
                  class: "number-input-item",
                  rules: positiveIntegerRules,
                  type: "number",
                  color: "primary",
                  label: _ctx.$t('GuildEconomy.subtitles.minimum')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(settings).messageXp.max,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(settings).messageXp.max) = $event)),
                  class: "number-input-item",
                  rules: positiveIntegerRules,
                  type: "number",
                  color: "primary",
                  label: _ctx.$t('GuildEconomy.subtitles.maximum')
                }, null, 8, ["modelValue", "label"])
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.moneyBonuses')), 1),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(settings).moneyBonuses.daily,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(settings).moneyBonuses.daily) = $event)),
                  class: "number-input-item",
                  rules: positiveIntegerRules,
                  type: "number",
                  color: "primary",
                  label: _ctx.$t('GuildEconomy.subtitles.daily')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(settings).moneyBonuses.weekly,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(settings).moneyBonuses.weekly) = $event)),
                  class: "number-input-item",
                  rules: positiveIntegerRules,
                  type: "number",
                  color: "primary",
                  label: _ctx.$t('GuildEconomy.subtitles.weekly')
                }, null, 8, ["modelValue", "label"])
              ])
            ])),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.customJobs')), 1),
        _createVNode(CustomJobs),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.shop')), 1),
        _createVNode(Items),
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('GuildEconomy.subtitles.resetBalance')), 1),
        _createVNode(ResetBalance, {
          guild: _unref(guild),
          class: "reset-balance"
        }, null, 8, ["guild"]),
        _createVNode(_component_v_btn, {
          class: "submit",
          disabled: _unref(valid) === false,
          loading: _unref(submitting),
          size: "large",
          color: "secondary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "save-icon" }, {
              default: _withCtx(() => [
                _createTextVNode("save")
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildEconomy.submit')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})